// Shared by Login, Signup and OTP pages

// MUI styles come from JS, so the input look lives in `sx` (pill fields, no floating label)
export const fieldSx = {
  "& .MuiOutlinedInput-root": {
    borderRadius: "999px",
    backgroundColor: "rgba(255,255,255,0.8)",
    fontFamily: "'DM Sans', sans-serif",
    "& input": { padding: "15px 22px" },
    "& fieldset": { borderColor: "#e2dcc0" },
    "&:hover fieldset": { borderColor: "#b9b293" },
    "&.Mui-focused fieldset": { borderColor: "#1f1d18", borderWidth: 2 },
  },
  "& .MuiFormHelperText-root": {
    fontFamily: "'DM Sans', sans-serif",
    marginLeft: "18px",
  },
};

export const focusRing =
  "focus-visible:outline focus-visible:outline-[3px] focus-visible:outline-offset-[3px] focus-visible:outline-ink/40";

export const primaryBtn = `h-[54px] w-full cursor-pointer rounded-full border-0 bg-brand font-sans text-base font-semibold text-ink transition-colors hover:bg-brand-deep active:translate-y-px disabled:cursor-progress disabled:opacity-60 motion-reduce:transition-none ${focusRing}`;

export const linkCls = `rounded text-ink underline underline-offset-2 hover:no-underline ${focusRing}`;
